export default "__VITE_ASSET__DUeph4Mj__"